import { Component,EventEmitter,Optional} from '@angular/core';
import { FormBuilder,Validators,ControlContainer,FormGroup  } from '@angular/forms';
import { Router } from '@angular/router';
import { PfmFundsDetailFormHelper,PfmFundsDetailFormState} from './pfm-funds-detail-form.helper';
import { BaseFpxFormComponent,ValidatorService } from '@fpx/core';
import { PfmfundsService } from '../pfmfunds-service/pfmfunds.service';
import { Pfmfunds } from '../pfmfunds-service/pfmfunds.model';
import { CommonService } from 'src/app/common.service';


@Component({
 selector: 'app-pfm-funds-detail-form',
  templateUrl: './pfm-funds-detail-form.component.html',
  styleUrls: ['./pfm-funds-detail-form.component.scss'],
  providers : [ PfmFundsDetailFormHelper]
  })

export class PfmFundsDetailFormComponent extends BaseFpxFormComponent<PfmFundsDetailFormHelper, PfmFundsDetailFormState> {
  constructor(
    @Optional() controlContainer: ControlContainer,
    formBuilder: FormBuilder,
    private router: Router,
    public pfmFundsDetailFormHelper: PfmFundsDetailFormHelper,
    public pfmfundsService: PfmfundsService,
    private validatorService: ValidatorService,
    public commonService:CommonService

  ) {
    super(formBuilder, router,controlContainer, pfmFundsDetailFormHelper);
  }
   protected override doPreInit(): void {

	this.setDataService(this.pfmfundsService);
  }


  protected override doPostInit(): void {

  }

}
